import { useEffect, useState } from 'react';

const Route = ({ path, children }) => {
    const [currentPath, setCurrentPath] = useState(window.location.pathname.split("?")[0]);
    const availableRoutes = [
        '',
        '/',
        '/bills',
        '/details',
        '/legislators',
        '/resources',
        '/state-bills',
        '/state-bill-details'
    ]

    useEffect(() => {
        // define callback as separate function so it can be removed later with cleanup function
        const onLocationChange = () => {
            setCurrentPath(window.location.pathname.split("?")[0])
            window.scrollTo(0, 0);
        }

        window.addEventListener('popstate', onLocationChange);

        // clean up event listener
        return () => {
            window.removeEventListener('popstate', onLocationChange)
        };
    }, [])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [currentPath])
    
    return currentPath === path ? children : availableRoutes.includes(currentPath) ? null : path === '*' ? children : null;
};

export default Route;
